import "../assets/style/misc/App.scss";

const NotFound = () => {
    return (
        <div className="fullscreen centered-column-container">
            <div className="centered-column-container spacing">
                <h1 className="page-title">Oups, page introuvable !</h1>
                <p className="page-subtitle">Il semble que la page que vous recherchez n’existe pas ou a été déplacée.</p>
                <p className="page-subtitle">Vous pouvez utiliser le menu pour continuer votre navigation, ou appuyer <a className="link" href="/">ici</a> pour revenir à l’accueil.</p>
            </div>
        </div>
    )
}

export default NotFound;